<emerald-side-navigation [header]="headerRef" [items]="allItems" (onClick)="handleMenuClick($event)"
    [nestedView]="'inline'"></emerald-side-navigation>
<ng-template #headerRef>
    <emerald-menu [id]="'menu0.6777514031539134'" [opened]="false" [position]="'absolute'"
        [iconOptions]="{icon: 'menu'}" [menuListWidth]="'150px'" [title]="isIconHovered ? 'Navigation Menu' : ''"
        (mouseenter)="isIconHovered = true" (mouseleave)="isIconHovered = false">
    </emerald-menu>
</ng-template>